import React from "react";
import { Navigation, Link, History } from "react-router";
import { Glyphicon } from "react-bootstrap";
import { ZOOM_ICON } from "js/config.jsx";
import Api from "js/utilities/fnapi-client";
import UserHandler from "js/utilities/user-handler";

// Store scroll position for sidebar menu
export const memoryStore = {
  _data: new Map(),
  get(key) {
    if (!key) {
      return null
    }

    return this._data.get(key) || null
  },
  set(key, data) {
    if (!key) {
      return
    }
    return this._data.set(key, data)
  }
}


export default React.createClass({

  defaultProps : {
    scrollStore: memoryStore
  },


  displayName : "sdk-sidebar",

  propTypes: {
    title: React.PropTypes.string.isRequired
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  mainMenu: [


  ],

  getInitialState: function() {
    var title = this.props.title

    if (this.props.menu) {
      var menu = this.props.menu
    }
    else {
      var menu = [

      ];

      menu = menu.concat(this.mainMenu)
    }

    return {
      title: title,
      menu: menu,
      newSessionCount: "",
      hasEnteredProduction: false
    }
  },

  handleImageLoaded() {
    this.setState({ imageStatus: "loaded" });
  },

  componentDidMount() {
    // Reset sidebar open menu on page refresh
    if (window.performance) {
      if (performance.navigation.type == 1) {
        UserHandler.removeOpenMenuItems();
      }
    }

    if (thisBrowser.name === "IE" && parseInt(thisBrowser.version) < 10) {
      var el = document.getElementsByClassName("parent")[0]
      el.setAttribute("style", "margin-top: -8px");
      el = document.getElementsByClassName("sidebar-title")[0]
      el.setAttribute("style", "margin-top: -8px");
    }
    this.fetchApplicationEnteredProduction();
    this.fetchUsageConsoleNewSessionCountData();

    // Open menu items stored in localStorage on page load
    if(UserHandler.getOpenMenuItems() != "") {
      var openMenuItemsNames = UserHandler.getOpenMenuItems();
      for (let key of Object.keys(openMenuItemsNames)) {
        if(openMenuItemsNames[key] == 1) {
          $("input[name= " + key + "]").prop( "checked", true );
        }
        if(openMenuItemsNames[key] == 0) {
          $("input[name= " + key + "]").prop( "checked", false );
        }
      }
    }

    this._target = this.sidebarDiv;
    this.restoreScrollPosition()
  },
  componentDidUpdate() {
      this.restoreScrollPosition()
  },

  componentWillUnmount() {
    this.saveScrollPosition()
  },

  // Restore scroll position
  restoreScrollPosition(pos) {
    pos = this.defaultProps.scrollStore.get("key");
    if (this._target && pos) {
        this.scroll(this._target, pos.x, pos.y)
    }
  },

  // Save scroll position
  saveScrollPosition(key) {
    if (this._target) {
      var target = this._target;
      const pos = { x: target.scrollLeft, y: target.scrollTop }
      this.defaultProps.scrollStore.set("key", pos)
    }
  },

  // Scroll sidebar to previous position
  scroll(target, x, y) {
    target.scrollLeft = x
    target.scrollTop = y
  },


  handleMenuClickEvent(elementId, event) {
    event.preventDefault();

    var element = $("#"+elementId);

    var openMenuItemsNames = {}
    if(UserHandler.getOpenMenuItems() != "") {
      openMenuItemsNames = UserHandler.getOpenMenuItems();
    }


    var menuName = element.attr("name");

    if(element.prop('checked')) {
      element.prop( "checked", false );
      openMenuItemsNames[menuName] = 0; // Store closed menu item in localStorage
    }
    else {
      element.prop( "checked", true );
      openMenuItemsNames[menuName] = 1; // Store open menu item in localStorage
    }
    UserHandler.setOpenMenuItems(openMenuItemsNames);

  },

  // Bootstrap 4 Accordion with Arrow up and Down Link : https://www.codehim.com/accordion/bootstrap-4-accordion-with-arrow-up-and-down/
  render: function() {
    var titleTag = ""
    if(titleTag != "") {
      if(titleTag.startsWith("ZoOm ") == true) {
        titleTag = titleTag.replace("ZoOm ", "")
      }
      document.title = "FaceTec | " + titleTag
    }
    else {
      document.title = "FaceTec - Developer Account"
    }


    var menuItems = this.state.menu.map(function (item, idx) {
      if(window.location.hash.indexOf(item.link) != -1) {
        titleTag = item.name
      }
      if (item.link.substring(0,5) == "https") {
        return (
          <li key={idx} ><a href={item.link} target="_blank">{item.name}</a></li>
        );
      }
      else {
        return (
          <li key={idx} ><Link to={item.link}>{item.name}</Link></li>
        );
      }
    }.bind(this));


    var searchbar = ""
    if(window.location.hash.indexOf("#/search") == -1) {
      searchbar =
          <form className="form-search form-inline" onSubmit={this.handleSearchSubmit}>
            <div className="input-group">
                <input type="text" className="form-control" ref="search" id="search" placeholder="Search Docs..." />
                <span className="input-group-addon" onClick={this.handleSearchSubmit}><i className="glyphicon glyphicon-search"></i></span>
            </div>
          </form>
    }

    return (
      <div className="sdk-sidebar" id="sidebar" ref={c => this.sidebarDiv =c}>
        <div className="sidebar-container">
          <div className="breadcrumb">
            <Link to={"/docs"}><img  onLoad={this.handleImageLoaded} className="home" src={ZOOM_ICON}/></Link>
          </div>
          <div id="stickyParent">
            <div id="sticky">
              {searchbar}

              <div className="container-fluid1">
               <div className="accordion-started accordion-menu row">
                  <div className="menu-item">
                     <input className="ac-input" id="ac-3" name="accordion-developer-overview" type="checkbox"/>
                     <label className="ac-label" htmlFor="ac-3" onClick={this.handleMenuClickEvent.bind(this, "ac-3")}>Fundamentals<i></i></label>
                     <div className="ac-content">
                        <Link to={UserHandler.loggedIn() ? "/account" : "/signin"}><div>Account & SDK Keys</div></Link>
                        <Link to="/server-dashboard-demo">
                          <div>
                              Dev/Demo Server Dashboard
                              {this.state.newSessionCount != "" &&
                                  <span className='console-notification-badge'>{this.state.newSessionCount}</span>
                              }
                          </div>
                        </Link>
                        <Link to="/zoom-configuration-options?link=zoom-architecture-and-configuration-options"><div>SDK Features & Options</div></Link>
                        <Link to="/zoom-configuration-options?link=hardware"><div>Customer Server Config</div></Link>
                        <Link to="/compatibility"><div>Compatibility</div></Link>
                        <Link to="/video-tutorials"><div>Video Tutorials</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-7"  name="accordion-configuration-customization" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-7" onClick={this.handleMenuClickEvent.bind(this, "ac-7")}>Customization<i></i></label>
                     <div className="ac-content">
                        <Link to="/ui-customization"><div>UX, Themes, & Branding</div></Link>
                        <Link to="/string-customization-guide"><div>Text & Language Editing</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-6" name="accordion-integration-guides" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-6" onClick={this.handleMenuClickEvent.bind(this, "ac-6")}>Device SDKs<i></i></label>
                     <div className="ac-content">
                        <Link to="/getting-started"><div>Getting Started</div></Link>
                        <Link to="/downloads"><div>Download SDKs</div></Link>
                        <Link to="/new-release-info"><div>New Release Info</div></Link>
                        <Link to="/webservice-guide"><div>FaceTec Testing API</div></Link>
                        <Link to="/data-types"><div>Audit Trail & ID Scan Images</div></Link>
                        <Link to="/zoom-sdk-size-and-app-thinning"><div>Reducing SDK Size</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-9"  name="accordion-security" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-9" onClick={this.handleMenuClickEvent.bind(this, "ac-9")}>Security<i></i></label>
                     <div className="ac-content">
                      <Link to="/security-best-practices"><div>Security Best Practices</div></Link>
                      <Link to="/facemap-encryption-keys"><div>FaceMap Encryption</div></Link>
                      <Link to="/session-tokens"><div>Session Tokens</div></Link>
                      <Link to="/zoom-client-side-security-methodologies"><div>Client-side Security</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-10"  name="accordion-accuracy-metrics" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-10" onClick={this.handleMenuClickEvent.bind(this, "ac-10")}>Metrics & Specs<i></i></label>
                     <div className="ac-content">
                      <Link to="/technical-specs"><div>Technical Info</div></Link>
                      <Link to="/matching-guide"><div>Face Matching (3D:3D & 2D:3D)</div></Link>
                      <Link to="/photo-id-match-guide"><div>Photo ID Matching (2D:3D)</div></Link>
                      <Link to="/photo-id-anti-spoofing-and-anti-tampering"><div>Photo ID Spoof Check</div></Link>
                      <Link to="/1-to-n-search"><div>1:N Search</div></Link>
                      <Link to="/2d-spoof-check"><div>2D Single-Frame Liveness</div></Link>
                      <Link to="/age-check-guide"><div>2D & 3D Age Checks</div></Link>
                      <Link to="/bias-and-success-rates"><div>Bias & Success Rates</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-8"  name="accordion-going-production" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-8" onClick={this.handleMenuClickEvent.bind(this, "ac-8")}>Going Production<i></i></label>
                     <div className="ac-content">
                        <Link to="/going-production-overview"><div>Overview</div></Link>
                        <Link to="/keys"><div>Device and Server SDK Keys</div></Link>
                        <Link to="/usage-logs"><div>Usage Logs</div></Link>
                        <Link to="/server-sdk-overview"><div>Server SDK Overview</div></Link>
                        <Link to="/standard-server-and-dashboard"><div>Standard Server & Dashboard</div></Link>
                        <Link to="/standard-server-rest-api"><div>Standard Server REST API</div></Link>
                        <Link to="/zoom-server-quickstart"><div>Custom Server Quickstart</div></Link>
                        <Link to="/server-integration"><div>Custom Server Implementation</div></Link>
                        <Link to="/zoom-server-rest-api"><div>Custom Server REST Sample Code API</div></Link>
                     </div>
                  </div>

                  <div className="menu-item">
                     <input className="ac-input" id="ac-12"  name="accordion-support" type="checkbox"  />
                     <label className="ac-label" htmlFor="ac-12" onClick={this.handleMenuClickEvent.bind(this, "ac-12")}>Help & Support<i></i></label>
                     <div className="ac-content">
                        <Link to="/faq"><div>FAQ</div></Link>
                        <Link to="/technical-support"><div>Technical Support</div></Link>
                        <Link to="/quote"><div>Request a Pricing Quote</div></Link>
                        <Link to="/glossary"><div>Glossary</div></Link>
                     </div>
                     <br /><br />
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },

  handleSearchSubmit: function(event) {
    event.preventDefault();
    return this.context.router.push('/search?key=' + this.refs.search.value);
  },

  // Get new sessions count for Server Dashboard page last visited
  fetchUsageConsoleNewSessionCountData: function() {
    if(UserHandler.getUsageConsoleLastVisited() == "") {
      UserHandler.setUsageConsoleLastVisited(Math.floor(Date.now() / 1000));
    }
    if(window.location.hash.indexOf("#/usage-console") == -1 && UserHandler.loggedIn()) {
      var time = UserHandler.getUsageConsoleLastVisited();
      if(time != "") {
        Api.get("account/current/zoom-server-console/new-sessions-count/" + time).then(( response ) => {
          if(response.data && response.data > 0) {
            this.setState({newSessionCount: response.data});
          }
        }).catch( (error) => {

        });
      }
    }
  },

  fetchApplicationEnteredProduction: function() {
    if(UserHandler.getHasEnteredProduction() != "") {
      this.setState({hasEnteredProduction: UserHandler.getHasEnteredProduction()});
    }
  },
});



// WEBPACK FOOTER //
// ./src/js/utilities/sdk-sidebar.jsx